export function refreshTab(tab, modal_appear = false) {
    tab = document.querySelector(`a[data-load-tab-type="${tab}"]`);
    if (tab) {
        if (modal_appear) {
            $(document).on('hidden.bs.modal', function () {
                $(tab).removeAttr('data-load-tab-rendered');
                $(tab).trigger('shown.bs.tab');
            })
        } else {
            $(tab).removeAttr('data-load-tab-rendered');
            $(tab).trigger('shown.bs.tab');
        }
    }
}
